import { Card, Flex, Text } from "@engaging-tech/components"
import { Spinner } from "@engaging-tech/components"
import React, { useState } from "react"
import { useTranslation } from "react-i18next"
import { useSelector } from "react-redux"
import styled from "styled-components"

import CircleAlarmClock from "../../../assets/icons/surveyIcons/CircleAlarmClock"
import Info from "../../../assets/icons/surveyIcons/Info"
import useGetSurveyResultEmail from "../hooks/useGetSurveyResultEmail"
import { getData, getEmailIndividualResult, getIndividualCode } from "../store/survey.selectors"
import EmailResent from "./emailResent"
import ResendEmail from "./resendEmail"
import SurveyLogo from "./surveyLogo"

const InfoContainer = styled.div`
  border-top: 1px solid ${({ theme }) => theme.colors.dark[4]};
  width: 90%;
  display: flex;
  gap: 5px;
  align-content: center;
  padding: 20px 5px;
  @media (max-width: 768px) {
    flex-direction: column;
  }
`

export default function ClosedSurvery() {
  const { t } = useTranslation(["organisation_survey"])
  const [emailResent, setEmailResent] = useState(false)
  const code = useSelector(getIndividualCode)
  const emailIndividualResultEnabled = useSelector(getEmailIndividualResult)
  const { surveyId } = useSelector(getData)
  const { data, getData: sendEmail, isLoading } = useGetSurveyResultEmail(surveyId, code, true, false)

  if (isLoading) return <Spinner justifyContent="center" color="light.0" width={1 / 1} />

  if (emailResent) return <EmailResent t={t} getData={sendEmail} setEmailResent={setEmailResent} />

  return (
    <Card bg="light.0" mt={[5, 5, 6]} mb={[6, 5]} elevation={8}>
      <Flex flexDirection="column" py={3} px={[3, 4]}>
        <SurveyLogo />
      </Flex>
      <Flex flexDirection="column" justifyContent="center" alignItems="center" width="100%">
        <CircleAlarmClock />
        <Text py={2} px={[3, 4]} font="Albert Sans" textAlign="center" fontSize={6} fontWeight={800}>
          This survey is closed
        </Text>
        <Text py={3} px={[3, 4]} font="Albert Sans" textAlign="center" fontSize={4}>
          Thank you for your interest in taking part. This survey has already finished, so your submission
          will not be recorded.
        </Text>
        {surveyId && code && emailIndividualResultEnabled && (
          <Flex pb={3} justifyContent="center">
            <ResendEmail setEmailResent={setEmailResent} sendEmail={sendEmail} />
          </Flex>
        )}
        <InfoContainer>
          <Info />
          <Text px={[1, 2]} font="Albert Sans" fontSize={3} color="dark.2" textAlign={["center", "start"]}>
            Think this is a mistake? Please contact the person who shared the survey link with you or reach
            out to the WorkL team at support@workl.com.{" "}
          </Text>
        </InfoContainer>
      </Flex>
    </Card>
  )
}
